import main from './main/main'

export default function(o, done){

  o.data.fullSequence(o,function(sequenceData){

    document.title = 'Open Memory Box | Coming Soon'

    // var slideshowDiv =
    //   o.component.slideshow(
    //     o,
    //     {
    //       markers: sequenceData.markers
    //     },
    //     function(){
    //       done(div)
    //     }
    //   )

    var mainDiv = main(o)

    var div = $('<div>')
    .css(o.mainDivCss)
    .addClass('iphoneNavbarFixTop')
    .addClass('iphoneNavbarFixBottom')
    .css({
      padding: '1rem',
      cursor: 'pointer',
      justifyContent: 'center',
      alignItems: 'center',
    })
    .append([

      // slideshowDiv
      // .css({
      //   position: 'fixed',
      //   display: 'flex',
      //   top: 0,
      //   bottom: 0,
      //   left: 0,
      //   right: 0,
      //   zIndex: 0,
      // }),

      $('<div>')
      .css({
        flex: '1 1 auto',
        zIndex: 1,
      }),

      mainDiv
      .css({
        flex: '0 0 auto',
        margin: '1rem',
        zIndex: 1,
      }),

      $('<div>')
      .css({
        flex: '1 1 auto',
        zIndex: 1,
      }),

    ])

    done(div)

  })

}



// WEBPACK FOOTER //
// ./src/client/view/frontend/views/comingSoon/comingSoon.js